import React, { useState } from 'react';

type Props = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  onEnter?: () => void;
  disabled?: boolean;
  style?: React.CSSProperties;
};

const baseInputStyle: React.CSSProperties = {
  width: '100%',
  background: 'var(--dark-3)',
  border: '1px solid rgba(201,168,76,0.2)',
  color: 'var(--text)',
  padding: '12px 44px 12px 16px',
  borderRadius: '4px',
  fontSize: '14px',
  outline: 'none',
};

// Reusable password field with a show/hide (eye) toggle button.
// Drop-in replacement for a plain <input type="password">.
const PasswordInput = ({ value, onChange, placeholder = 'Password', onEnter, disabled, style }: Props) => {
  const [show, setShow] = useState(false);

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <input
        type={show ? 'text' : 'password'}
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        onChange={e => onChange(e.target.value)}
        onKeyDown={e => e.key === 'Enter' && onEnter && onEnter()}
        style={{ ...baseInputStyle, opacity: disabled ? 0.5 : 1, ...style }}
      />
      <button
        type="button"
        onClick={() => setShow(s => !s)}
        disabled={disabled}
        aria-label={show ? 'Hide password' : 'Show password'}
        title={show ? 'Hide password' : 'Show password'}
        style={{
          position: 'absolute',
          right: '12px',
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'transparent',
          border: 'none',
          cursor: disabled ? 'default' : 'pointer',
          color: 'var(--text-muted)',
          fontSize: '16px',
          padding: 0,
          lineHeight: 1,
        }}
      >
        {show ? '🙈' : '👁️'}
      </button>
    </div>
  );
};

export default PasswordInput;
